<template>
  <div class="content">
    <p class="form-title">基本信息</p>
    <el-form
      class="form"
      :model="ruleForm"
      ref="form"
      label-width="110px"
      label-position="right"
      :rules="rules"
      :disabled="formDisabled"
    >
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="ruleForm.sort"
          controls-position="right"
          :disabled="getFormDisabled()"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="机构类型" prop="orgTypeName">
        <el-input placeholder="请填写机构类型" v-model="ruleForm.orgTypeName" disabled></el-input>
      </el-form-item>
      <el-form-item label="产品类型" prop="productType">
        <el-select
          v-model="ruleForm.productType"
          clearable
          placeholder="请选择产品类型"
          :disabled="getFormDisabled()"
        >
          <el-option label="科技贷款" :value="1" />
          <el-option label="普惠贷款" :value="2" />
          <el-option label="担保" :value="3" />
          <el-option label="科技保险" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="机构名称" prop="investmentFirmsId" v-if="ruleForm.productType !== 4">
        <el-select
          v-model="ruleForm.investmentFirmsId"
          filterable
          clearable
          remote
          :remote-method="getAllInvestmentFirms"
          placeholder="请填写企业名称"
          :popper-append-to-body="false"
          @change="detailInfo"
          style="width: 100%;text-align: left;"
          :disabled="getFormDisabled()"
        >
          <el-option
            v-for="item in investmentFirms"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品名称" prop="name">
        <el-input
          placeholder="请填写产品名称"
          v-model="ruleForm.name"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="行业" prop="industryId" v-if="ruleForm.productType !== 4">
        <el-select
          v-model="ruleForm.industryId"
          clearable
          placeholder="请选择行业"
          @change="selectChange('industry', industryOptions)"
          :disabled="getFormDisabled()"
        >
          <el-option
            v-for="item in industryOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="覆盖地域" prop="productSuitableJson" v-if="ruleForm.productType !== 4">
        <el-select
          v-model="ruleForm.productSuitableJson"
          multiple
          clearable
          placeholder="请选择覆盖地域"
          :disabled="getFormDisabled()"
        >
          <el-option
            v-for="item in areaOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品适用对象" prop="applicableObjects">
        <el-input
          placeholder="请填写产品适用对象"
          v-model="ruleForm.applicableObjects"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品简介" prop="introduction">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入产品简介"
          v-model="ruleForm.introduction"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="补偿范围" prop="compensationScope" v-if="ruleForm.productType === 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入补偿范围"
          v-model="ruleForm.compensationScope"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="费率标准" prop="rateStandard" v-if="ruleForm.productType === 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入费率标准"
          v-model="ruleForm.rateStandard"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="免赔标准" prop="deductibleThreshold" v-if="ruleForm.productType === 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入免赔标准"
          v-model="ruleForm.deductibleThreshold"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="功能特点" prop="features" v-if="ruleForm.productType !== 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入功能特点"
          v-model="ruleForm.features"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="办理条件" prop="handleCondition" v-if="ruleForm.productType !== 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入办理条件"
          v-model="ruleForm.handleCondition"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请流程" prop="applyProcess" v-if="ruleForm.productType !== 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入申请流程"
          v-model="ruleForm.applyProcess"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-row v-if="ruleForm.productType !== 4">
        <el-col :span="15">
          <el-form-item label="年化率（%）" prop="numberRange">
            <InputNumberRange
              :precision="2"
              v-model="ruleForm.numberRange"
              @input="inputChange($event, 'numberRange')"
              :disabled="getFormDisabled()"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.productType !== 4">
        <el-col :span="15">
          <el-form-item label="贷款额度（万元）" prop="financeRange">
            <InputNumberRange
              :precision="2"
              v-model="ruleForm.financeRange"
              @input="inputChange($event, 'financeRange')"
              :disabled="getFormDisabled()"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="贷款期限" prop="financingTermId" v-if="ruleForm.productType !== 4">
        <el-select
          v-model="ruleForm.financingTermId"
          clearable
          placeholder="请选择贷款期限"
          @change="selectChange('financingTerm', financingTermOptions)"
          :disabled="getFormDisabled()"
        >
          <el-option
            v-for="item in financingTermOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="contactPerson" v-if="ruleForm.productType !== 4">
        <el-input
          placeholder="请填写联系人"
          v-model="ruleForm.contactPerson"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="contactInformation" v-if="ruleForm.productType !== 4">
        <el-input
          placeholder="请填写联系方式"
          v-model="ruleForm.contactInformation"
          :disabled="getFormDisabled()"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布时间" prop="publishedTime">
        <el-date-picker
          v-model="ruleForm.publishedTime"
          type="date"
          placeholder="选择发布时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          :disabled="getFormDisabled()"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="封面图" prop="logo">
        <el-upload
          class="avatar-uploader"
          :action="this.uploadURL"
          name="file"
          :show-file-list="false"
          :file-list="logo"
          :on-success="
            (response, file, fileList) => handlePictureCardPreview(response, file, fileList, 'logo')
          "
          :before-upload="beforeAvatarUpload"
          :disabled="getFormDisabled()"
        >
          <img v-if="ruleForm.logo" :src="logo[0].url" class="img_border" />
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
            :class="{ is_border: !ruleForm.logo }"
          ></i>
          <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
          <span v-else class="upload_btn">更换图片</span>
        </el-upload>
        <span class="del_img" v-show="ruleForm.logo && !ruleForm.id">
          <i class="el-icon-error" @click="deleteImg('logo')"></i>
        </span>
      </el-form-item>
      <el-form-item label="发布" prop="publishedFlag">
        <el-switch v-model="ruleForm.publishedFlag" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
      <el-form-item label="审批状态" prop="approvalStatus" style="text-align:left">
        <el-select
          v-model="ruleForm.approvalStatus"
          placeholder="请选择审核状态"
          style="display: block;"
          :disabled="formDisabled"
        >
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="不通过" :value="2"></el-option>
          <el-option label="退回" :value="3"></el-option>
          <el-option label="通过" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <!-- 金融产品留言暂不做 -->
      <!-- <template v-if="messageId && messages.length > 0">
        <p class="form-title">留言板</p>
        <el-row v-for="(item, index) in messages" :key="item.id">
          <el-form-item :label="'留言' + (index + 1)">
            <label class="form-label">发布</label>
            <el-switch v-model="item.publishedFlag" @change="messageSwitch(item)" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>
          <el-form-item label="留言信息">
            <el-input placeholder="请填写留言信息" v-model="item.content"></el-input>
          </el-form-item>
          <el-form-item label="留言回复">
            <el-input
              placeholder="请填写回复内容"
              v-model="item.answer"
              style="width: 93%;margin-right: 20px;"
            ></el-input>
            <el-button type="text" @click="answerClick(item)">提交</el-button>
          </el-form-item>
        </el-row>
      </template> -->
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import InputNumberRange from "@/components/inputNumberRange"
export default {
  components: {
    InputNumberRange
  },
  props: ['formDisabled',  'messageId'],
  data() {
    return{
      investmentFirms: [],
      industryOptions: [],
      areaOptions: [{
					value: "兰州市",
					label: "兰州市",
				},{
					value: "嘉峪关市",
					label: "嘉峪关市",
				},{
					value: "金昌市",
					label: "金昌市",
				},{
					value: "白银市",
					label: "白银市",
				},{
					value: "天水市",
					label: "天水市",
				},{
					value: "武威市",
					label: "武威市",
				},{
					value: "张掖市",
					label: "张掖市",
				},{
					value: "酒泉市",
					label: "酒泉市",
				},{
					value: "平凉市",
					label: "平凉市",
				},{
					value: "庆阳市",
					label: "庆阳市",
				},{
					value: "定西市",
					label: "定西市",
				},{
					value: "陇南市",
					label: "陇南市",
				},{
					value: "临夏回族自治州",
					label: "临夏回族自治州",
				},{
					value: "甘南藏族自治州",
					label: "甘南藏族自治州",
				},],
      financingTermOptions:[],
      ruleForm: {
        orgType: null, // 机构类型
        orgTypeName: null, // 机构类型名称
        investmentFirmsId: null, // 金融机构id
        investmentFirmsName: null, // 金融机构名称
        name: null, // 产品名称
        industryId: null, // 行业id
        industryName: null, // 行业名称
        productSuitableJson: [], // 覆盖地域json类型有前端维护
        applicableObjects: null, // 产品适用对象
        introduction: null, // 产品简介
        features: null, // 功能特点
        handleCondition: null, // 办理条件
        applyProcess: null, // 申请流程
        financingAmount: null,
        financingAmountMin: null, // 融资额度最少
        financingAmountMax: null, // 融资额度最多
        financeRange: [], // 融资额度
				numberRange: [], //
        annualizedRateMin: null, // 年化率最小
        annualizedRateMax: null, // 年化率最大
        financingTermId: null, // 融资期限id
        financingTermName: null, // 融资期限名称
        contactPerson: null, // 联系人
        contactInformation: null, // 联系方式
        publishedFlag: false, // 是否发布
        logo: null,
        approvalStatus: 4
      },
      rules: {
        investmentFirmsId: [{
					required: true,
					message: "请填写机构名称",
					trigger: "blur"
				}],
        name: [{
					required: true,
					message: "请填写产品名称",
					trigger: "blur"
				}],
				industryId: [{
					required: true,
					message: "请选择行业",
					trigger: "change"
				}],
        productSuitableJson: [{
          required: true,
					message: "请选择覆盖地域",
					trigger: "change"
        }],
        applicableObjects: [{
					required: true,
					message: "请填写产品适用对象",
					trigger: "blur"
				}],
        introduction: [{
          required: true,
					message: "请填写产品产品简介",
					trigger: "blur"
        }],
        features: [{
          required: true,
					message: "请填写功能特点",
					trigger: "blur"
        }],
        // handleCondition: [{
        //   required: true,
				// 	message: "请填写办理条件",
				// 	trigger: "blur"
        // }],
        // applyProcess: [{
        //   required: true,
				// 	message: "请填写申请流程",
				// 	trigger: "blur"
        // }],
        // numberRange: [{
        //   type: 'array',
        //   required: true,
        //   message: "请输入年化率",
        //   trigger: ["blur", "change"], len: 2
        // }],
				financeRange: [{
          type: 'array',
          required: true,
          message: "请输入贷款额度",
          trigger: ["blur", "change"],
          len: 2
        }],
        financingTermId: [{
					required: true,
					message: "请选择贷款期限",
					trigger: "change"
				}],
        contactPerson: [{
          required: true,
					message: "请填写联系人",
					trigger: "blur"
        }],
        contactInformation: [{
          required: true,
					message: "请填写联系方式",
					trigger: "blur"
        }],
        publishedTime: [{
					required: true,
					message: "请选择发布时间",
					trigger: "change"
				}],
        logo: [{
					required: true,
					message: "请选择logo",
					trigger: "change"
				}],
			},
      messages: [],
      logo: []
    }
  },
  methods: {
    getFormDisabled() {
      if(this.ruleForm.disabled){
        return true
      }
      return false
    },
    deleteImg() {
      this.logo = []
      this.ruleForm.logo = null
    },
    handlePictureCardPreview(response, file, fileList, type) {
      console.log(fileList)
			// this.ruleForm.logo = file.data.store_result;
      if (response.code == 0) {
        let arr = []
        if(fileList.length > 0) {
          // fileList.map(item => {
            arr.push({
              url: file.size ? this.imgUrl + file.response.data.store_result : file.url,
              name: file.name
            });
          // });
        }
        if(arr.length > 0) {
          this[type] = arr;
          this.ruleForm[type] = JSON.stringify(arr);
        }else{
          this.ruleForm[type] = '';
          this[type] = [];
        }
      }
		},
    beforeAvatarUpload(file) {
			let type = false;
			if (
				file.type === "image/jpeg" ||
				file.type === "image/png" ||
				file.type === "image/jpg" ||
				file.type === "image/gif" ||
				file.type === "image/bmp"
			) {
				type = true;
			}

			const isLt2M = file.size / 1024 / 1024 < 30;
			if (!type) {
				this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 30MB!");
			}
			return type && isLt2M;
		},
    selectChange(prop, list) {
      const item = list.find((item => item.id === this.ruleForm[prop+'Id']));
      if(item) {
        this.ruleForm[prop + 'Name'] = item.label
      }
    },
    inputChange(val, props) {
      if(val[0]) {
        this.ruleForm[props][0] = val[0]
      }else{
        delete this.ruleForm[props][0]
        this.ruleForm[props].length = 1
      }
      if(val[1]) {
        this.ruleForm[props][1] = val[1]
      }else{
        delete this.ruleForm[props][1]
        this.ruleForm[props].length = 1
      }
      console.log('this.numberRange', this.ruleForm[props])
    },

    detailInfo(value) {
      const item = this.investmentFirms.find(item => item.value === value);
      this.ruleForm.investmentFirmsName = item.label;
      this.ruleForm.orgType = item.orgType;
      this.ruleForm.orgTypeName = item.orgTypeName;
    },
    getAllInvestmentFirms(item) {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/getList`, {keyword: item, is_page: 1, dataType: 2})
      .then((res) => {
        if (res.code == 0) {
          this.investmentFirms = res.data.map((item)=>{
            return {
              label: item.orgName,
              value: item.id,
              orgType: item.orgType,
              orgTypeName: item.orgTypeName
            }
          });
        }
      });
    },
    parentHandleclick(e) {
      if(this.ruleForm.id) {
        this.handleParams(e);
      } else {
        this.$refs.form.validate((val) => {
          if (val) {
            this.handleParams(e);
          }
        });
      }
    },
    handleParams(e) {
      this.ruleForm.annualizedRateMin = this.ruleForm.numberRange[0]
      this.ruleForm.annualizedRateMax = this.ruleForm.numberRange[1]
      this.ruleForm.financingAmountMin = this.ruleForm.financeRange[0]
      this.ruleForm.financingAmountMax = this.ruleForm.financeRange[1]
      const params = {
        approvalStatus: 1,
        dataSrc: 3,
        ...this.ruleForm,
        publishedFlag: this.ruleForm.publishedFlag ? 1 : 0
      }
      params.productSuitableJson = JSON.stringify(this.ruleForm.productSuitableJson)
      e && e(params)
    },
    answerClick(item) {
      item.isAnswer = true
    },
    messageSwitch(item) {

    },
    getGroup() {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
          dictTypes: ['financial_industry', 'financial_financing_term']
        })
        .then(res => {
          if (res.code === 0) {
            const { financial_industry, financial_financing_term } = res.data;
            this.industryOptions = [...financial_industry];
            this.industryOptions.unshift({id:0, label:"不限行业"});
            this.financingTermOptions = [...financial_financing_term];
          }
        });
    },
    initDate(id) {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/product/get?id=${id}`)
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              ...res.data
            };
            this.ruleForm.publishedFlag = Boolean(res.data.publishedFlag);
            this.investmentFirms = [{
              label: res.data.investmentFirmsName,
              value: res.data.investmentFirmsId,
              orgType: res.data.orgType,
              orgTypeName: res.data.orgTypeName
            }];
            this.ruleForm.industryId = res.data.industryId;
            this.ruleForm.financingTermId = res.data.financingTermId;
            if(res.data.productSuitableJson) {
              this.ruleForm.productSuitableJson = JSON.parse(this.ruleForm.productSuitableJson)
            }
            this.logo = res.data.logo ? JSON.parse(res.data.logo) : []
            this.ruleForm.financeRange = []
						this.ruleForm.numberRange = []
            this.ruleForm.orgTypeName = res.data.investmentFirmsTypeName
						this.ruleForm.financeRange[0] = res.data.financingAmountMin
						this.ruleForm.financeRange[1] = res.data.financingAmountMax
						this.ruleForm.numberRange[0] = res.data.annualizedRateMin
						this.ruleForm.numberRange[1] = res.data.annualizedRateMax
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
    },
    getMessagePage(id) {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/product-message/page`, {
          financeProductId: id,
          is_page: 1
        })
        .then(res => {
          if (res.code === 0) {
            this.messages = res.data.data;
          }
        });
    }
  },
  created() {
    this.getGroup();
    if(this.messageId) {
      this.initDate(this.messageId);
      // this.getMessagePage(this.messageId);
    }
  },
}
</script>

<style scoped lang="scss">
.content {
  .form-title {
    padding-left: 20px;
    font-size: 14px;
    font-weight: bold;
  }
  .form-label {
    padding-right: 10px;
  }
  .del_img {
    position: absolute;
    top: -7px;
    left: 220px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  /deep/ {
    .el-input,
    .el-select {
      width: 100%;
    }
  }

  /deep/ .el-upload {
    width: 243px;
    height: 198px;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  /deep/ .upload-demo {
    margin-top: 10px;
    /deep/.el-upload {
      /deep/.el-button {
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background: rgba(66, 141, 255, 1);
        border-radius: 18px;
        padding: 10px 25px;
      }
    }
  }
}
</style>
